import { TreeInstance } from '@headless-tree/core';
import { useContext } from 'react';
import { InternalTreeItem } from 'shared/components/ui/virtualized-tree-list';

import { TreeDispatchContext, TreeValueContext } from './context';

export const useTreeValue = (): TreeInstance<InternalTreeItem> | undefined => {
  return useContext(TreeValueContext);
};

export const useTreeDispatch = (): React.Dispatch<
  React.SetStateAction<TreeInstance<InternalTreeItem> | undefined>
> => {
  return useContext(TreeDispatchContext);
};

/**
 * @deprecated Use useTreeValue or useTreeDispatch instead
 */
export const useTree = (): [
  TreeInstance<InternalTreeItem> | undefined,
  React.Dispatch<
    React.SetStateAction<TreeInstance<InternalTreeItem> | undefined>
  >,
] => {
  const tree = useTreeValue();
  const setTree = useTreeDispatch();
  return [tree, setTree];
};
